import React, {Component} from 'react';
import './App.css';
import AppLayout from "./components/app-layout/AppLayout";
import Footer from "./components/footer/Footer";
import Authenticator from "./components/authenticator/Authenticator";
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Instructor from "./routes/instructor/Instructor";
import WorldControlPanel from "./routes/world-control-panel/WorldControlPanel";
import AppLoader from "./components/app-loader/AppLoader";
import InfoContainer from "./routes/info/InfoContainer";

class App extends Component {
    state = {
        loading: true,
    };

    componentDidMount = () => {
      setTimeout(() => {
          this.setState(() =>({loading: false}));
      }, 2400)
    };

    render() {

        return (
            <AppLayout>
                <AppLoader display={this.state.loading}/>
                <Router>
                    <Switch location={window.location}>
                        <Route exact path="/" component={Authenticator}/>
                        <Route exact path="/student/:skey/:pid/:sname/:opener" component={Authenticator}/>
                        <Route exact path="/instructor" component={Instructor}/>
                        <Route exact path="/info" component={InfoContainer}/>
                        <Route path="/instructor/world/" component={WorldControlPanel}/>
                        <Route path="/instructor/world/:skey/CLSG" component={WorldControlPanel}/>
                    </Switch>
                </Router>

                <Footer/>
            </AppLayout>
        );
    }
}

export default App;
